import axios from "axios";
import {server} from "@/variables";

export function getManagers() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/managers`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function deleteManager(managerId) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.delete(`${server}/managers/${managerId}`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function updateManager(managerId, phone) {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.post(`${server}/managers/${managerId}`,{ phone },  {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function getManagersList() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/list/managers`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}

export function syncManagers() {
    const token = localStorage.getItem('token');
    return new Promise((resolve, reject) => {
        axios.get(`${server}/sync/managers`, {headers: {'admin-token': token}})
            .then((data) => {
                return resolve(data.data)
            })
            .catch(err => {
                reject(err);
            });
    })
}